import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ViewportService {
	private lastOrientation: number | null = null;
	private baseHeight: number | null = null;
	private _isMobile: boolean;

	/** Prüft ob das Gerät ein mobiles Gerät ist (Android, iPhone, iPad, iPod) */
	get isMobile(): boolean {
		return this._isMobile;
	}

	constructor() {
		// Erkennung ob mobiles Gerät (für URL-Bar Logik und PDF-Vorschau)
		const userAgentMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
		const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
		const isSmallScreen = window.innerWidth <= 1024;
		this._isMobile = userAgentMobile || (hasTouchScreen && isSmallScreen);

		// Initial setzen
		this._updateViewportHeight(true);

		// Auf Orientierung reagieren
		window.addEventListener('orientationchange', () => {
			this._updateViewportHeight(true);
			setTimeout(() => this._updateViewportHeight(true), 100);
			setTimeout(() => this._updateViewportHeight(true), 300);
		});

		// Desktop: Standard window resize Event
		window.addEventListener('resize', () => this._handleWindowResize());

		// Mobile: visualViewport für Keyboard-Erkennung
		if (this._isMobile) {
			window.visualViewport?.addEventListener('resize', () => this._handleMobileResize());
		}
	}

	private _handleWindowResize() {
		if (!this._isMobile) {
			const vh = window.innerHeight;
			this.baseHeight = vh;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		}
	}

	private _handleMobileResize() {
		const currentHeight = window.visualViewport?.height ?? window.innerHeight;
		const currentOrientation = window.orientation ?? 0;

		if (this.lastOrientation !== currentOrientation) {
			this._updateViewportHeight(true);
			return;
		}

		if (this.baseHeight && currentHeight < this.baseHeight - 100) {
			document.documentElement.style.setProperty('--vh', `${currentHeight}px`);
		} else if (this.baseHeight && currentHeight >= this.baseHeight - 100) {
			document.documentElement.style.setProperty('--vh', `${this.baseHeight}px`);
		}
	}

	private _updateViewportHeight(isOrientationChange = false) {
		const vh = window.visualViewport?.height ?? window.innerHeight;
		this.lastOrientation = window.orientation ?? 0;

		if (isOrientationChange || !this.baseHeight) {
			this.baseHeight = vh;
		}

		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
}
